import React, { Component } from 'react';
import { Layout, Icon, Modal, Button } from 'antd';
import { history } from '@RouterAdmin';
import { Debounce, Bind } from 'lodash-decorators';
import { API_LOGOUT, API_GET_SUPPLIER_LIST } from '@api';
import { getData, getSupplierCode, getSupplierName } from '@util';
import styles from '../style/globalHeader.scss';
import { connect } from 'react-redux';
import { mapDispatchToProps } from '../../../redux/map';
import TaskCenter from './TaskCenter/index.jsx';
import MessageCenter from './MessageCenter/index.jsx';
import _ from 'lodash';
import { CsxSelect, CsxSearch } from '@Form';
import { topSelect } from './mock';
import { getVariant, setVariant, removeVariant, hasVariant } from '@Variant';

const { Header } = Layout;
const navArr = [
  {
    name: '首页',
    path: '/home/index',
  },
];
const navArr2 = [
  {
    name: '我的资料',
    path: '/home/profile',
  },
];

export function logOut(callback) {
  getData({ api: API_LOGOUT });
  callback && typeof callback == 'function' && callback();
  window.localStorage.clear();
  window.sessionStorage.clear();
  history.replace('/');
}
@connect(state => ({ ...state }), mapDispatchToProps)
export default class GlobalHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      confirmLoading: false, // 弹出框 按钮loading
      visible: false, // 是否显示弹出框
      type: '0', // 弹框类型
      collapsed: false,
      localData: null,
      showSelectData: {
        supplierCode: null,
        supplierName: null,
      },
      isTemporarySupplier: false,
      isIntendedSupplier: false,
    };
  }
  componentDidMount() {
    this.setState({
      localData: hasVariant('userInfos') ? JSON.parse(getVariant('userInfos')) : {},
      defaultSupplier: getVariant('defaultSupplier'),
      showSelectData: {
        value: getSupplierCode(),
        children: getSupplierName(),
      },
      isTemporarySupplier: getVariant('isTemporarySupplier'),
      isIntendedSupplier: getVariant('isIntendedSupplier'),
    });
  }

  toggle = () => {
    const { collapsed, onCollapse } = this.props;
    onCollapse(!collapsed);
    this.triggerResizeEvent();
  };

  @Bind()
  @Debounce(600)
  triggerResizeEvent() {
    const event = document.createEvent('HTMLEvents');
    event.initEvent('resize', true, false);
    window.dispatchEvent(event);
  }

  _choosePath = item => {
    if (item && item.item) {
      const keyPath = `/${item.item.props.keyPath}`;
      if (window.location.pathname == keyPath) return false;
      history.replace(keyPath);
    }
  };

  _logOut = () => this.setState({ visible: true, type: '0' });

  /*--------- 弹出框 ---------- */

  /* 退出 确定按钮 */
  handleLogputOk = () => {
    this.setState({ confirmLoading: true });

    logOut(() => this.setState({ confirmLoading: false, visible: false }));
  };

  /* 取消按钮 */
  handleCancel = () => this.setState({ visible: false });

  /* 提示框类型选择 */
  switchType = value => {
    if (value === '0') {
      return (
        <LogoutPopUp
          wrapClassName=""
          visible={this.state.visible}
          onOk={this.handleLogputOk}
          onCancel={this.handleCancel}
          loading={this.state.confirmLoading}
        />
      );
    }
  };

  handleLink = item => {
    history.push(item.path);
  };

  onInputChange = data => {
    const { defaultSupplier, isTemporarySupplier, isIntendedSupplier } = this.state;
    const newDefaultSupplier = {};
    newDefaultSupplier.supplierCode = data.value;
    newDefaultSupplier.supplierName = data.children;

    setVariant('useClickSupplier', newDefaultSupplier);
    setVariant('fetchHeader', newDefaultSupplier.supplierCode);
    this.setState({
      defaultSupplier: { ...defaultSupplier, ...newDefaultSupplier },
    });
    if (isTemporarySupplier) {
      history.push('/home/profile');
    } else if (isIntendedSupplier) {
      history.push('/home/intendedSupplier');
    } else {
      history.push('/home/index');
    }
    window.location.reload();
  };

  onUserInput = data => {
    if (!data) {
      removeVariant('useClickSupplier');
      removeVariant('fetchHeader');
    }
    this.setState({
      showSelectData: data,
    });
  };

  render() {
    const { collapsed, userLoation, isPaper } = this.props;
    const { localData, showSelectData, defaultSupplier, isTemporarySupplier, isIntendedSupplier } =
      this.state;
    let isSuperSupplier;
    try {
      const userInfos = hasVariant('userInfos') ? JSON.parse(getVariant('userInfos')) : {};
      isSuperSupplier = userInfos.isSuperSupplier;
    } catch (err) {
      console.log('左侧菜单err', err);
    }
    const nav = isTemporarySupplier || isIntendedSupplier ? navArr2 : navArr;
    return (
      <Header className={styles.header}>
        <Icon
          className={styles.trigger}
          type={collapsed ? 'menu-unfold' : 'menu-fold'}
          onClick={this.toggle}
        />
        <div
          className={styles.headerMenu}
          onClick={this._choosePath}
          style={{ lineHeight: '60px', float: 'left' }}>
          {nav?.map((item, index) => (
            <div key={index} onClick={this.handleLink.bind(this, item)}>
              {' '}
              {item.name}
            </div>
          ))}
        </div>
        <div
          style={{
            position: 'absolute',
            right: '49px',
            top: '10px',
            display: 'flex',
            alignItem: 'flex-start',
          }}>
          {!isTemporarySupplier &&
          !isIntendedSupplier &&
          (hasVariant('useClickSupplier') || hasVariant('defaultSupplier')) ? (
            isPaper ? (
              <div className={styles.headerIconBox}>
                <img src="../../../../image/nopapericon.png" />
                <h5 className={styles.notHasPaper}>无纸化</h5>
              </div>
            ) : (
              <div className={styles.headerIconBox}>
                <img src="../../../../image/headericon.png" />
                <h5 className={styles.isHasPaper}>有纸化</h5>
              </div>
            )
          ) : null}
          {isSuperSupplier &&
          Number(isSuperSupplier) === 1 &&
          !isTemporarySupplier &&
          !isIntendedSupplier ? (
            <CsxSearch
              allowClear={false}
              antd={{ allowClear: false }}
              boxWidth="100%"
              style={{ height: '32px' }}
              dateApi={API_GET_SUPPLIER_LIST}
              searchParamsKey="keyword"
              selectItem={{
                data: showSelectData,
                key: 'supplierCode',
                valueKey: ['supplierCode', 'supplierName'],
              }}
              onChangeSelect={value => {
                this.onUserInput(value);
              }}
              onSelect={value => {
                this.onUserInput(value);
                this.onInputChange(value);
              }}
            />
          ) : (
            !isTemporarySupplier &&
            !isIntendedSupplier && (
              <CsxSelect
                allowClear={false}
                antd={{ allowClear: false }}
                data={getVariant('userInfos') && JSON.parse(getVariant('userInfos'))?.supplierList}
                showBoth={true}
                selectItem={{
                  data: {
                    value: getSupplierCode(),
                    children: getSupplierName(),
                  },
                  key: 'supplierCode',
                  valueKey: ['supplierCode', 'supplierName'],
                }}
                onChangeSelect={value => {
                  this.onInputChange(value);
                }}
              />
            )
          )}
          {!isTemporarySupplier && !isIntendedSupplier && (
            <TaskCenter
              taskType={'csx-b2b-settle-schedul'}
              taskType2={'csx-b2b-supplier-schedule'} // 采购获取下载列表
              taskType3="csx-b2b-tms-schedule"
              taskType4="csx-b2b-scm-web-schedul"
              sysCode={'TASK-SCHEDULING'}
              timeOut={10000}
              history={history}
              // itemExtra={taskCenterItemExtra}
            />
          )}
        </div>

        <div onClick={this._logOut} className={styles.logout}></div>
        {this.state.visible && this.state.type && this.switchType(this.state.type)}
      </Header>
    );
  }
}

/* 退出 弹出框 */
class LogoutPopUp extends Component {
  render() {
    const { wrapClassName, visible, onOk, onCancel, loading } = this.props;

    return (
      <Modal
        wrapClassName={wrapClassName}
        visible={visible}
        title="系统提示"
        onOk={onOk}
        onCancel={onCancel}
        footer={[
          <Button key="back" onClick={onCancel}>
            取消
          </Button>,
          <Button key="submit" type="primary" loading={loading} onClick={onOk}>
            确定
          </Button>,
        ]}>
        <p style={{ textIndent: '40px' }}>确认退出登录？</p>
      </Modal>
    );
  }
}
